import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function ShareLinkExpirationModal({ isOpen, onClose, onSubmit }) {
  const [expirationDate, setExpirationDate] = useState(null);

  useEffect(() => {
    if (isOpen) {
      const date = new Date();
      date.setDate(date.getDate() + 7);
      setExpirationDate(date);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = () => {
    if (!expirationDate) {
      alert("Please select an expiration date");
      return;
    }

    const now = new Date();
    const diffTime = expirationDate - now;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays <= 0) {
      alert("Please select a future date");
      return;
    }

    onSubmit(diffDays);
    setExpirationDate(null);
  };

  const handleClose = () => {
    setExpirationDate(null);
    onClose();
  };

  return (
    <div
      style={{ backgroundColor: "rgba(0, 0, 0, 0.2)" }}
      className="flex overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%)] max-h-full"
    >
      <div className="relative w-full max-w-xs max-h-full p-4">
        <div className="relative bg-white rounded-lg shadow">
          <div className="flex items-center justify-between p-4 border-b rounded-t">
            <h3 className="text-lg font-semibold text-gray-900">
              Set Link Expiration
            </h3>
            <button
              onClick={handleClose}
              type="button"
              className="inline-flex items-center justify-center w-8 h-8 text-sm text-gray-400 bg-transparent rounded-lg hover:bg-gray-200 hover:text-gray-900"
            >
              <FontAwesomeIcon icon={faTimes} className="w-4 h-4" />
            </button>
          </div>

          <div className="p-6 space-y-4">
            <div>
              <label className="block mb-2 text-sm font-medium text-gray-900">
                Expiration Date
              </label>
              <DatePicker
                selected={expirationDate}
                onChange={(date) => setExpirationDate(date)}
                dateFormat="dd/MM/yyyy"
                minDate={new Date()}
                placeholderText="Select or type date (DD/MM/YYYY)"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                showYearDropdown
                showMonthDropdown
                dropdownMode="select"
                wrapperClassName="w-full"
              />
            </div>
          </div>

          <div className="flex items-center justify-end p-4 space-x-2 border-t rounded-b">
            <button
              onClick={handleClose}
              type="button"
              className="text-gray-500 bg-white hover:bg-gray-100 border border-gray-300 font-medium rounded-lg text-sm px-5 py-2.5"
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              type="button"
              className="text-white bg-[#ffa270] hover:bg-[#ffa270]/80 font-medium rounded-lg text-sm px-5 py-2.5"
            >
              Create Link
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}